// Reglas puras del borrador local (sin DOM): clave, versión, caducidad, "prístino", antigüedad y URL
// del blob; `node --test`. Doc: _docs/features/products/product_wizard_draft.md

export const DRAFT_VERSION = 1
export const MAX_AGE_DAYS = 7
export const SAVE_DELAY = 500

export function draftKey({ storeId }) {
  return `product-draft:v${DRAFT_VERSION}:store-${storeId}:new`
}

export function buildDraft(parts, now = new Date()) {
  return { version: DRAFT_VERSION, savedAt: now.toISOString(), ...parts }
}

// JSON del storage → objeto, o null si no es un borrador
export function parseDraft(json) {
  try {
    const value = JSON.parse(json)
    return value && typeof value === "object" && !Array.isArray(value) ? value : null
  } catch {
    return null
  }
}

// Sirve si es de este formato, de esta tienda, de Crear producto y no caducó
export function isUsable(draft, { storeId, now = new Date(), maxAgeDays = MAX_AGE_DAYS }) {
  if (!draft || draft.version !== DRAFT_VERSION || draft.mode !== "create") return false
  if (Number(draft.storeId) !== Number(storeId)) return false
  const saved = Date.parse(draft.savedAt)
  if (!Number.isFinite(saved)) return false
  return now - saved <= maxAgeDays * 86400000
}

// Trix deja "<div><br></div>" o "&nbsp;" en un editor vacío
export function emptyHtml(html) {
  return String(html || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim() === ""
}

// Nada escrito ni decidido: no hay qué guardar y es el único estado sobre el que se ofrece un borrador
export function isPristine(draft) {
  const product = draft?.product || {}
  const price = draft?.price || {}
  const options = draft?.options || {}
  return !product.name && !product.photo && !product.sectionId && !(product.categoryIds || []).length &&
    emptyHtml(product.description) && !price.amount && !price.discount?.active && !price.stock?.active &&
    (options.hasOptions === null || options.hasOptions === undefined)
}

// "hace un momento" · "hace 5 min" · "hace 3 h" · "hace 2 días"
export function ageText(savedAt, now = new Date()) {
  const saved = Date.parse(savedAt)
  if (!Number.isFinite(saved)) return ""
  const minutes = Math.floor((now - saved) / 60000)
  if (minutes < 1) return "hace un momento"
  if (minutes < 60) return `hace ${minutes} min`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `hace ${hours} h`
  const days = Math.floor(hours / 24)
  return `hace ${days} ${days === 1 ? "día" : "días"}`
}

// Un blob sin attachment se sirve por la ruta proxy de ActiveStorage
export function blobProxyPath(signedId, filename) {
  return `/rails/active_storage/blobs/proxy/${signedId}/${encodeURIComponent(filename || "foto")}`
}

// DirectUploadsController#destroy: purga solo blobs sin attachment (la foto de un borrador descartado)
export function uploadPurgePath(signedId) {
  return `/direct_uploads/${signedId}`
}

// Borrador vigente o null; uno que no sirve se borra al leerlo; sin storage no hay borrador
export function readDraft(storage, key, { storeId, now = new Date() }) {
  try {
    const draft = parseDraft(storage.getItem(key))
    if (isUsable(draft, { storeId, now })) return draft
    if (draft) storage.removeItem(key)
  } catch {
    // sin storage no hay borrador
  }
  return null
}
